<template>
  <div>
    <Mainlayout></Mainlayout>
    <!-- badan page -->
    <CCard class="h-100">
      <CCol sm="12" class="justify-content-center m-0">
        <CContainer>
            <br /><br />
          <CCol sm="12" lg="12">
            <h3>Select Subject</h3>
            <CCard v-if="!quizExam.length">
              <div class="mt-5 text-center mb-5">
                <img src="../assets/img/nodata.png" width="120px" />
                <br />
                <br />
                <span class="custom-font"> No quiz available yet</span>
              </div>
            </CCard>

            <CCard
              v-for="item in quizExam"
              v-bind:key="item.subjectId"
              body-wrapper
              style="background: #ebedef; border: 1px solid #009688"
              text-color="black"
              class="box-shadow"
              @click="GoToPageExamList(item.subjectId)"
            >
              <CRow>
              <!-- subject image  -->
                <div class="col-3">
                  <div v-if="item.subjectName == 'Mathematics'">
                    <img
                      src="../assets/img/maths.png"
                      width="50px"
                    />
                  </div>
                  <div v-else-if="item.subjectName == 'Additional Mathematics'">
                    <img
                      src="../assets/img/iconaddmath.png"
                      width="50px"
                    />
                  </div>
                    <div v-else-if="item.subjectName == 'Science'">
                    <img
                      src="../assets/img/science.png"
                      width="50px"
                    />
                  </div>
                   <div v-else-if="item.subjectName == 'Physics'">
                    <img
                      src="../assets/img/physics.png"
                      width="50px"
                    />
                  </div>
                    <div v-else-if="item.subjectName == 'Chemistry'">
                    <img
                      src="../assets/img/chemistry.png"
                      width="50px"
                    />
                  </div>
                    <div v-else-if="item.subjectName == 'Biology'">
                    <img
                      src="../assets/img/iconbiology.png"
                      width="50px"
                    />
                  </div>
                    <div v-else-if="item.subjectName == 'Sejarah'">
                    <img
                      src="../assets/img/iconhistory.png"
                      width="50px"
                    />
                  </div>
                   <div v-else-if="item.subjectName == 'Geografi'">
                    <img
                      src="../assets/img/icongeography.png"
                      width="50px"
                    />
                  </div>

                    <div v-else-if="item.subjectName == 'Information and Communication Technology'">
                    <img
                      src="../assets/img/iconit.png"
                      width="50px"
                    />
                  </div>
                    <div v-else-if="item.subjectName == 'Bahasa Inggeris'">
                    <img
                      src="../assets/img/iconenglish.png"
                      width="50px"
                    />
                  </div>
                  
                  <div v-else>
                    <img
                      src="../assets/img/iconsubject.png"
                      width="50px"
                    />
                  </div>
                </div>

                <!-- Total Quiz Count -->
                <div class="col-9">
                  <h6 class="ml-2 mr-2 mb-2 text-black custom-font">
                    <strong>{{ item.subjectName }}</strong>
                  </h6>
                  <p class="ml-2 mr-2 text-black custom-font">Term Exam {{ item.totalQuizCount }}</p>
                </div>
              </CRow>
              <div class="bottom-view-right">
                <span style="color: rgb(33 162 162)">
                  <strong> View</strong>
                </span>
                &nbsp; <CIcon name="cil-chevron-right" />
              </div>
            </CCard>
          </CCol>
        </CContainer>
      </CCol>
    </CCard>
  </div>
</template>


<script>
import Vue from "vue";
Vue.use(require("vue-moment"));
import vSelect from "vue-select";
import moment from "moment";
import backgroundBanner from "../assets/img/bgApps.jpg";
import _ from "lodash";
import VuejsDialog from "vuejs-dialog";
import "vuejs-dialog/dist/vuejs-dialog.min.css";
Vue.component("v-timepicker", VueTimepicker);
Vue.component("v-select", vSelect);
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
import "vue-select/dist/vue-select.css";
import "vue-select/src/scss/vue-select.scss";
import Mainlayout from "../containers/TheHeaderWebStudent.vue";
// Tell Vue to install the plugin.
Vue.use(VuejsDialog);
export default {
  name: "Login",
  components: {
    PulseLoader,
    Mainlayout
  },
  data() {
    return {
      backgroundBanner,
      SubmittedForm: false,
      Error: false,
      quizExam: []
    };
  },
  async mounted() {
    //this.GetSubject();
    //this.GetGrade();
    this.QuizStudentRecordBySubjectId();
  },
  computed: {},
  methods: {
    async QuizStudentRecordBySubjectId() {
      this.$API
        .get(
          this.$QuizStudentRecordBySubjectId +
            "?studentId=" +
            this.$route.query.studentId,
          {
            withCredentials: true
          }
        )
        .then(response => {
          if (response.status == 200 && response.data != null) {
            this.quizExam = response.data;
          }
        });
    },
    GoToPageExamList(subjectId) {
      this.$router.push(
        "/QuizStudentExamList?userId=" +
          this.$route.query.userId +
          "&studentId=" +
          this.$route.query.studentId +
          "&subjectId=" +
          subjectId
      );
    }
  }
};
</script>
